import styled from "styled-components";
import { colors } from "globalStyles";

export const Wrapper = styled.div`
  width: 300px;
  padding-top: 34px;
  color: ${colors.BODY};
`;

export const Text = styled.div`
  font-size: 16px;
  line-height: 24px;
  > a,
  > a:hover {
    text-decoration: underline;
  }
`;

export const Ul = styled.ul`
  padding-left: 5px;
  margin: 0;
  font-size: 14px;
  line-height: 19px;
  list-style: none;
`;

export const Li = styled.li`
  &:before {
    line-height: 0px;
    content: "\\2022";
    font-size: 20px;
    padding: 0 12px 0 0;
    color: #c9d7df;
    display: inline-block;
    vertical-align: middle;
  }
`;



// WEBPACK FOOTER //
// ./src/components/VerificationResentFailureModal/styledComponents.js